import { defineStore } from 'pinia';
import Menu from '@/data/menu.json';
import BonusUI from '@/data/bonusui';

// Ancho máximo (px) en el que el menú se comporta como móvil; coincide con
// `max-width: 991.98px` de src/assets/scss/themes/_responsive.scss.
export const MOBILE_MAX_WIDTH = 991;
const esAnchoMovil = () => window.innerWidth <= MOBILE_MAX_WIDTH;

export const useMenuStore = defineStore('menu', {
  state: () => ({
    data: Menu.data,
    megamenu: BonusUI.data,
    searchData: [],
    togglesidebar: false,
    activeoverlay: false,
    esMovil: esAnchoMovil(),
    searchOpen: false,
    customizer: '',
    hideRightArrowRTL: false,
    hideLeftArrowRTL: true,
    hideRightArrow: true,
    hideLeftArrow: true,
    width: 0,
    height: 0,
    margin: 0,
    menuWidth: 0,
  }),

  getters: {},

  actions: {
    opensidebar() {
      this.togglesidebar = !this.togglesidebar;
      this.activeoverlay = this.esMovil && this.togglesidebar;
    },
    // Cierra menú y velo solo en móvil; en escritorio respeta la elección de la persona.
    cerrarSidebarMovil() {
      if (!this.esMovil) return;
      this.togglesidebar = false;
      this.activeoverlay = false;
    },
    // Solo reacciona al cruzar el umbral móvil/escritorio: ahí deja el menú colapsado/cerrado.
    resizetoggle() {
      const esMovil = esAnchoMovil();
      if (esMovil === this.esMovil) return;
      this.esMovil = esMovil;
      this.togglesidebar = false;
      this.activeoverlay = false;
    },
    searchTerm(term) {
      let items = [];
      var searchval = term.toLowerCase();
      this.data.filter((menuItems) => {
        if (menuItems.title) {
          if (menuItems.title.toLowerCase().includes(searchval) && menuItems.type === 'link') {
            items.push(menuItems);
          }
          if (!menuItems.children) return false;
          menuItems.children.filter((subItems) => {
            if (subItems.title.toLowerCase().includes(searchval) && subItems.type === 'link') {
              subItems.icon = menuItems.icon;
              items.push(subItems);
            }
            if (!subItems.children) return false;
            subItems.children.filter((suSubItems) => {
              if (suSubItems.title.toLowerCase().includes(searchval)) {
                suSubItems.icon = menuItems.icon;
                items.push(suSubItems);
              }
            });
          });
        }
      });
      this.searchData = items;
    },
    setBonusNavActive(item) {
      if (!item.active) {
        this.megamenu.forEach((a) => {
          if (this.megamenu.includes(item)) a.active = false;
          if (!a.children) return false;
          a.children.forEach((b) => {
            if (a.children.includes(item)) {
              b.active = false;
            }
          });
        });
      }
      item.active = !item.active;
    },
    setNavActive(item) {
      if (!item.active) {
        this.data.forEach((a) => {
          if (this.data.includes(item)) a.active = false;
          if (!a.children) return false;
          a.children.forEach((b) => {
            if (a.children.includes(item)) {
              b.active = false;
            }
          });
        });
      }
      item.active = !item.active;
    },
    setActiveRoute(item) {
      this.data.filter((menuItem) => {
        if (menuItem !== item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item)) menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              menuItem.active = true;
              submenuItems.active = true;
            }
          });
        }
      });
    },
  },
});

